import { useEffect, useId, useState } from 'react';
import { Input } from './ui/input';
import ListLoading from './ListLoading';
import { cn } from '../lib/utils';

export default function SearchSuggestions({ value, onChange, onSelect, options, immediateOptions = [], loading, error, renderOption, emptyLabel = "Keine passenden Ergebnisse gefunden.", footer, showEmpty = false, inputRef, dropdownClassName, ...inputProps }) {
  const listId = useId();
  const [open, setOpen] = useState(false);
  const [highlighted, setHighlighted] = useState(-1);
  const query = value.trim().toLocaleLowerCase('de');
  const matches = error ? [] : loading ? immediateOptions : options;
  const expanded = !inputProps.disabled && open && (showEmpty || Boolean(query));
  useEffect(() => {
    if (expanded && highlighted >= 0) document.getElementById(`${listId}-${highlighted}`)?.scrollIntoView({ block: 'nearest' });
  }, [expanded, highlighted, listId]);
  const choose = service => {
    if (inputProps.disabled) return;
    onSelect(service);
    setOpen(false);
    setHighlighted(-1);
  };
  return <div className="relative" onBlur={event => {
    if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false);
  }}>
    <Input {...inputProps} ref={inputRef} value={value} role="combobox" aria-autocomplete="list" aria-expanded={expanded}
      aria-controls={expanded ? listId : undefined}
      aria-activedescendant={expanded && matches[highlighted] ? `${listId}-${highlighted}` : undefined}
      autoComplete="off"
      onFocus={() => { setOpen(true); setHighlighted(-1); }}
      onChange={event => { onChange(event.target.value); setOpen(true); setHighlighted(-1); }}
      onKeyDown={event => {
        if (event.key === 'Escape' && expanded) { event.preventDefault(); event.stopPropagation(); setOpen(false); }
        else if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && (query || showEmpty)) {
          event.preventDefault(); setOpen(true);
          setHighlighted(current => !matches.length ? -1 : current < 0 ? (event.key === 'ArrowDown' ? 0 : matches.length - 1) : (current + (event.key === 'ArrowDown' ? 1 : -1) + matches.length) % matches.length);
        } else if (event.key === 'Enter' && expanded && matches[highlighted]) {
          event.preventDefault(); choose(matches[highlighted]);
        }
      }} />
    {expanded && <div className={cn("absolute left-0 right-0 top-full z-50 mt-1 max-h-48 overflow-y-auto rounded-xl border border-[#E5E5EA] bg-white shadow-lg", dropdownClassName)}>
      {loading && !matches.length ? <ListLoading compact label="Ergebnisse werden geladen …" /> : error ? <p role="status" className="px-3 py-3 text-sm text-[#86868B]">{error}</p> : null}
      <div id={listId} role="listbox" aria-label={inputProps["aria-label"] || "Suchergebnisse"}>
        {matches.map((service, index) => <button key={service.id} id={`${listId}-${index}`} type="button" role="option" tabIndex={-1} aria-selected={highlighted === index}
          onMouseDown={event => event.preventDefault()} onClick={() => choose(service)}
          className={`flex w-full items-center justify-between gap-3 px-3 py-3 text-left text-sm text-[#1D1D1F] ${highlighted === index ? 'bg-[#F5F5F7]' : 'hover:bg-[#FAFAFB]'}`}>
          {renderOption(service)}
        </button>)}
      </div>
      {!loading && !error && !matches.length && <p className="px-3 py-3 text-sm text-[#86868B]">{emptyLabel}</p>}
      {loading && matches.length > 0 && <p role="status" className="px-3 py-2 text-xs text-[#86868B]">Weitere Treffer werden gesucht …</p>}
      {footer && <p className="border-t px-3 py-2 text-xs text-[#86868B]">{footer}</p>}
    </div>}
  </div>;
}


export function patientContact(patient) {
  const email = String(patient?.email || '').trim();
  return /@phone\.booking\.internal\.example$/i.test(email) ? (patient?.phone || '') : (email || patient?.phone || '');
}
export function patientOption(patient) {
  return <span className="min-w-0"><span className="block font-medium">{patient.first_name} {patient.last_name}</span>{patientContact(patient) && <span className="block truncate text-xs text-[#86868B]">{patientContact(patient)}</span>}</span>;
}
